export default __webpack_public_path__ + "static/media/proj7.1d91784e.png";